export default class BaseSobrevivenciaRequest {
  constructor(
    public canal: string,
    public codUsuario: string,
    public numPreSolicitud: number
  ) {}
}
